export const PathRouteConstants = {
  indexRoute: "",
  loginRoute: "/login",
  changePasswordRoute: "/change-password",
  productsRoute: "/products",
  productDetailsRoute: "/products/:productId",
  productInsertRoute: "/products/insert",
  ordersRoute: "/orders",
  orderDetailsRoute: "/orders/:orderId",
  reviewsRoute: "/reviews",
  reviewDetailsRoute: "/reviews/:reviewId",
  reviewInsertRoute: "/reviews/insert",
  reviewTypesRoute: "/reviewTypes",
  reviewTypeDetailsRoute: "/reviewTypes/:reviewTypeId",
  reviewTypeInsertRoute: "/reviewTypes/insert",
  tipsRoute: "/tips",
  tipDetailsRoute: "tips/:tipId",
  tipInsertRoute: "/tips/insert",
  policiesRoute: "/policies",
  policyDetailsRoute: "/policies/:type",
  newsListRoute: "/news",
  newsDetailsRoute: "/news/:newsId",
  newsInsertRoute: "/news/insert",
  categoriesRoute: "/categories",
  categoryDetailsRoute: "/categories/:categoryId",
  categoryInsertRoute: "/categories/insert",
  informationRoute: "/information",
  shippingsRoute: "/shippings",
  shippingDetailsRoute: "/shippings/:shippingType",
  websiteRoute: "/website",
  languagesRoute: "/language",
  customersRoute: "/customer",
  tagsRoute: "/tags",
  tagInsertRoute: "/tags/insert",
  tagDetailsRoute: "/tags/:tagId",
  paymentMethodsRoute: "/payment-method",
  promotionCodesRoute: "/promotion-code",
  promotionCodeInsertRoute: "/promotion-code/insert",
  promotionCodeDetailsRoute: "/promotion-code/edit",
};
